var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-alert"},[(_vm.error)?_c('b-alert',{attrs:{"dismissible":"","show":"","variant":_vm.variant},on:{"dismissed":_vm.dismissed}},[_vm._v(_vm._s(_vm.$t(_vm.error)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }